module.exports = __webpack_public_path__ + "static/media/montserrat-latin-200-normal.c030ea95.woff2";